import { useEffect } from 'react';
import { useIsGlobalLoadingQuery } from '../../generated/graphql';
import { useIsGlobalLoading } from '../../hooks/useIsGlobalLoading';
import { isGlobalLoadingVar } from './Common.variables';
import Loader from './Loader';

export default function GlobalLoading() {
  const { data } = useIsGlobalLoadingQuery();
  const isLoading = data?.isGlobalLoading;
  const { setGlobalLoading } = useIsGlobalLoading(isGlobalLoadingVar);

  useEffect(() => {
    window.addEventListener('popstate', closeGlobalLoading);
    return () => {
      window.addEventListener('popstate', closeGlobalLoading);
    };
  }, []);

  const closeGlobalLoading = () => {
    setGlobalLoading(false);
  };

  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed z-99999 top-0 left-0 w-full h-full bg bg-global-loading-black bg-opacity-50 display flex flex-col items-center justify-center">
      <Loader size={20} loading={isLoading} />
    </div>
  );
}
